import React from "react";
import PrivateRoute from "./utils/PrivateRoute";
import Dashboard from "components/Dashboard/Dashboard";
import SupervisorDashboard from "components/supervisor/SupervisorDashboard/SupervisorDashboard";
import UserAdminDashboard from "components/UserAdminDashboard/UserAdminDashboard";
import SalesOpportunities from "components/Sales/Opportunities/SalesOpportunities";

function Routes() {
  return (
    <>
      <PrivateRoute path="/admin" exact component={UserAdminDashboard} />
      <PrivateRoute path="/dashboard" exact component={Dashboard} />
      <PrivateRoute path="/supervisor" exact component={SupervisorDashboard} />
      <PrivateRoute path="/sales-opportunities" exact component={SalesOpportunities} />
    </>
  );
}

export default Routes;
